import barba from "@barba/core";
import gsap from "gsap";
import Vue from "vue";
import Lazyload from "../vendor/croustille/image/lazyload";

export default {
  init() {
    this.before = new Event("barba");
    this.headerClose = new Event("header:close");
    window.lazyloading = new Lazyload();

    this.app = new Vue({
      el: "#app",
    });

    window.lazyloading.init();

    try {
      barba.hooks.before((data) => {
        // console.log("before");
        this.app && this.app.$destroy();
        document.dispatchEvent(this.before);
      });

      barba.hooks.beforeEnter((data) => {
        document.dispatchEvent(this.headerClose);
        document.documentElement.dataset.colorScheme =
          data.next.container.dataset.barbaColorScheme;
        document.documentElement.dataset.logo =
          data.next.container.dataset.barbaLogo;
        window.scrollTo(0, 0);
      });

      barba.hooks.after((data) => {
        // console.log("after");
        this.app = new Vue({
          el: "#app",
        });

        window.lazyloading.reset();
      });

      barba.init({
        transitions: [
          {
            name: "opacity-transition",
            leave(data) {
              return gsap.to(data.current.container, {
                opacity: 0,
              });
            },
            enter(data) {
              return gsap.from(data.next.container, {
                opacity: 0,
              });
            },
          },
        ],
      });
    } catch (error) {
      console.error(error);
    }
  },
};
